export default __webpack_public_path__ + "static/media/icon_front-end.0f26b9ea.svg";